import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  CardActions,
  Box,
  Button,
  Rating,
} from "@mui/material";
import NavigationBar from "../../../components/NavigationBar"; // Asegúrate de importar el NavigationBar
import { getProducts } from "../../../services/modules/Productos";

const Productos = () => {
  const [productos, setProductos] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getProducts(); // Trae los productos desde Firebase
        setProductos(data);
      } catch (error) {
        console.error("Error al cargar productos:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {/* NavigationBar */}
      <NavigationBar />

      {/* Catálogo de Productos */}
      <Container sx={{ marginTop: "30px", marginBottom: "30px" }}>
        <Typography
          variant="h4"
          gutterBottom
          textAlign="center"
          sx={{ marginBottom: "20px" }}
        >
          Catálogo de Productos
        </Typography>
        <Grid container spacing={4}>
          {productos.map((producto) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={producto.id}>
              <Card
                sx={{
                  boxShadow: 3,
                  borderRadius: 2,
                  textAlign: "center",
                  padding: "16px",
                }}
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={producto.imageUrl || "https://via.placeholder.com/300x200"}
                  alt={producto.name}
                  sx={{ objectFit: "contain", marginBottom: "16px" }}
                />
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {producto.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    {producto.description}
                  </Typography>
                  <Rating name="read-only" value={4} readOnly size="small" />
                  <Typography variant="h5" color="primary" gutterBottom>
                    Q. {producto.price}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    variant="contained"
                    fullWidth
                    color="primary"
                    onClick={() =>
                      window.open(
                        `https://wa.me/50238278976?text=Hola,%20quisiera%20información%20sobre%20el%20producto:%20${encodeURIComponent(
                          producto.name
                        )}`,
                        "_blank"
                      )
                    }
                  >
                    Comprar
                  </Button>
                </CardActions>
                <Box sx={{ marginTop: "16px" }}>
                  <Typography variant="caption" color="text.secondary">
                    Más detalles aquí...
                  </Typography>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </>
  );
};

export default Productos;
